import React from 'react';

export default function WorkoutEditorRow({ summaryCard, children }) {
  return (
    <div className="w-full border-b border-gray-200 pb-6 last:border-b-0 last:pb-0 pt-6 first:pt-0">
      <div className="flex gap-4 items-center flex-wrap">
        {summaryCard}
        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}
